export interface CurrentUser {
  id: string
  name: string
  email: string
  role: 'client' | 'admin' | 'super_admin'
  token: string
}

export function getCurrentUser(): CurrentUser | null {
  try {
    const raw = sessionStorage.getItem('rb_current_user')
    if (!raw) return null
    const user = JSON.parse(raw) as CurrentUser
    if (!user?.id || !user?.token) return null
    if (!user.name) user.name = ''
    return user
  } catch {
    return null
  }
}

export function setCurrentUser(user: CurrentUser): void {
  sessionStorage.setItem('rb_current_user', JSON.stringify(user))
}

export function clearCurrentUser(): void {
  sessionStorage.removeItem('rb_current_user')
}
